import React, { useState } from 'react';
import { Button } from 'antd';
import FilterModal from '../layouts/NavigationBar/FilterModal';
import useScreenSize from '../../hooks/useScreenSize';

const SelectReport = () => {
  const [open, setOpen] = useState(true);
  const { isDesktop, isMobile, isTablet } = useScreenSize();
  return (
    <div style={{ padding: 24 }} data-testid="select-report-page">
      <h1 style={{ fontSize: 24, fontWeight: 'bold', color: 'rgb(15, 103, 136)', textTransform: 'uppercase' }}>Select Report</h1>
      <p style={{ color: '#555' }}>Choose a project, region, council, date range, and report to proceed. Other sections are disabled until a report is selected.</p>
      <Button type="primary" data-testid="open-filters-button" onClick={() => setOpen(true)}>Open Filters</Button>
      <FilterModal
        isOpen={open}
        onClose={() => setOpen(false)}
        enforceSelection={true}
        isDesktop={isDesktop}
        isMobile={isMobile}
        isTablet={isTablet}
      />
    </div>
  );
};

export default SelectReport;
